export const courseGroups = {
    top: [
        "CTFL",
        "internship",
        "SQL-basics",
        "J-SW-tester",
        "GEN-AI"
    ],
    beginner: [
        "CTFL",
        "CTFL-6days",
        "J-SW-tester",
        "career-debug",
        "internship",
        "SQL-basics",
    ],
    advanced: [
        "S-SW-tester",
        "SQL-advanced",
        "CTAL-TA",
        "CTAL-TM",
    ],
    automatization: [
        "CTAL-TAE",
        "test-automation-principles",
        "GEN-AI",
        "test-automation",
        "learn-programming"
    ],
    itSpecialists: [
        "CTFL",
        "test-automation-principles",
        "SQL-basics",
        "SQL-advanced",
    ],
    agile: [
        "CTFL",
        "SCRUM-basics",
        "SCRUM-master",
    ],
};